import React from 'react'
import { AppToolbarCreateButton } from "@components"
import { useCreateUsersModal } from "Pages/Admin/Users/@hooks"


export default function AdminUsersTableToolbar() {
	const { onOpenModal } = useCreateUsersModal()

	return <AppToolbarCreateButton label="Create User" onClick={() => onOpenModal()}/>
}
